// @flow

import * as React from 'react';
import classNames from 'classnames';

import Tappable from 'app/components/commons/Tappable';
import InputField from 'app/components/commons/InputField';

type Props = {
  display: Array<Object>,
  label?: string,
  onChange: () => void,
  value?: number,
  scheme: 'light' | 'dark'
};

const defaultProps = {
  label: '',
  value: null
};

function MoneySelector({ display, label, onChange, scheme, value }: Props) {
  return (
    <div className="columns">
      <div className="column is-half">
        <span>{label}</span>
        <div className="form-field-group">
          <div className="toggle-buttons">
            {display.map(d => (
              <Tappable
                key={d.value}
                className={classNames('toggle-button', {
                  'toggle-button-active': value === d.value
                })}
                onTap={() => onChange(d.value)}
              >
                {d.label}
              </Tappable>
            ))}
          </div>
        </div>
      </div>
      <div className="column is-half">
        <span>Other amount</span>
        <div className="toggle-buttons">
          <span className="toggle-button toggle-button-active" style={{ flex: 'none' }}>
            AUD $
          </span>
          <InputField
            size="small"
            name="state"
            type="number"
            placeholder="Amount"
            value={value || ''}
            onChange={val => onChange(parseInt(val, 10))}
            noMargin
            lightContent={scheme === 'light'}
          />
        </div>
      </div>
    </div>
  );
}

MoneySelector.defaultProps = defaultProps;

export default MoneySelector;
